import TopicsPageV3 from './TopicsPageV3'

export default TopicsPageV3
// eslint-disable-next-line import/export
export * from './TopicsPageV3'
